import * as Types from '../../../types.generated';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type ViewAsMenuItemPersonQueryVariables = Types.Exact<{
  id: Types.Scalars['Int']['input'];
}>;


export type ViewAsMenuItemPersonQuery = { __typename?: 'Query', AdminEmployee?: { __typename?: 'Employee', id: number, name: string, userType: Types.UserType, email?: string | null, deactivatedAt?: string | null } | null };


export const ViewAsMenuItemPersonDocument = gql`
    query ViewAsMenuItemPerson($id: Int!) {
  AdminEmployee(id: $id) {
    id
    name
    userType
    email
    deactivatedAt
  }
}
    `;

/**
 * __useViewAsMenuItemPersonQuery__
 *
 * To run a query within a React component, call `useViewAsMenuItemPersonQuery` and pass it any options that fit your needs.
 * When your component renders, `useViewAsMenuItemPersonQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useViewAsMenuItemPersonQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useViewAsMenuItemPersonQuery(baseOptions: Apollo.QueryHookOptions<ViewAsMenuItemPersonQuery, ViewAsMenuItemPersonQueryVariables> & ({ variables: ViewAsMenuItemPersonQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ViewAsMenuItemPersonQuery, ViewAsMenuItemPersonQueryVariables>(ViewAsMenuItemPersonDocument, options);
      }
export function useViewAsMenuItemPersonLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ViewAsMenuItemPersonQuery, ViewAsMenuItemPersonQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ViewAsMenuItemPersonQuery, ViewAsMenuItemPersonQueryVariables>(ViewAsMenuItemPersonDocument, options);
        }
export type ViewAsMenuItemPersonQueryHookResult = ReturnType<typeof useViewAsMenuItemPersonQuery>;
export type ViewAsMenuItemPersonLazyQueryHookResult = ReturnType<typeof useViewAsMenuItemPersonLazyQuery>;
export type ViewAsMenuItemPersonQueryResult = Apollo.QueryResult<ViewAsMenuItemPersonQuery, ViewAsMenuItemPersonQueryVariables>;